import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Select from 'components/shared/Select';
import ReservationList from 'components/ReservationPage/ReservationList';
import DatePickerMobile from 'components/ReservationPage/DatePickerMobile';
import MyReservation from 'components/ReservationPage/MyReservation';
import moment from 'moment';
import RadioButton from 'components/shared/RadioButton';
import styles from './styles.module.css';

const handleClubs = clubs => {
  if (!Array.isArray(clubs)) return [];
  const activeClubs = clubs.map(club => {
    if (club.totalCapacity > 0) return { label: club.name, value: club.sfId };
    return {
      label: club.name,
      value: club.sfId,
      isDisabled: true,
    };
  });
  return activeClubs;
};

const MainContentMobile = ({
  datesRange,
  targetDate,
  targetClub,
  targetRoom,
  handleChangeRoom,
  handleChangeClub,
  handleSelectDate,
  reservations,
  upcomingReservations,
  handleSlotClick,
  isRequesting,
}) => {
  const [clubsOptions, setClubsOptions] = useState([]);
  const [closedClubText, setClosedClubText] = useState('');
  const clubs = useSelector(state => state.clubs.clubs);
  const rooms = useSelector(state => state.clubs.rooms);
  const activeLocationClub = useSelector(state => state.clubs.activeLocationClub);
  const favoriteLocationClubSfId = useSelector(state => state.auth.user.favoriteLocation);

  useEffect(() => {
    setClubsOptions(handleClubs(clubs));
  }, [clubs]);

  useEffect(() => {
    if (Array.isArray(rooms)) {
      handleChangeRoom(rooms[0]?.id);
    }
    // eslint-disable-next-line
  }, [rooms]);

  useEffect(() => {
    if (!targetClub && activeLocationClub?.length && activeLocationClub[0].sfId) {
      const isActiveFavoriteClub =
        activeLocationClub?.length > 0 &&
        activeLocationClub.find(c => c.sfId === favoriteLocationClubSfId);

      if (!targetClub && isActiveFavoriteClub) handleChangeClub(favoriteLocationClubSfId);
      else if (!targetClub && activeLocationClub?.length && activeLocationClub[0].sfId) {
        handleChangeClub(activeLocationClub[0].sfId);
      }
    }
    // eslint-disable-next-line
  }, [clubsOptions, targetClub, handleChangeClub, activeLocationClub]);

  useEffect(() => {
    const club = clubs.find(({ sfId }) => targetClub === sfId);
    setClosedClubText(
      `${club?.name} is closed on ${moment(targetDate?.date).format('dddd')}`
    );
    // eslint-disable-next-line
  }, [targetClub, targetDate]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerSection}>
        <p className={styles.chooseTimeSlot}>Choose a Location:</p>
        <div className={styles.selectWrapper}>
          <Select
            hideBorder
            width="100%"
            height="100%"
            hideIndicatorSeparator
            options={clubsOptions}
            value={targetClub}
            onChange={e => {
              handleChangeClub(e.value);
            }}
          />
        </div>

        {rooms?.length > 0 && (
          <div className={styles.select}>
            <p className={styles.chooseTimeSlot}>Select a gym:</p>
            <div className={styles.rooms}>
              {rooms.map(el => (
                <div
                  onClick={() => handleChangeRoom(el.id)}
                  key={el.id}
                  className={styles.room}
                >
                  <RadioButton value={targetRoom === el.id} />
                  <p>{el.title}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {upcomingReservations.length ? (
        <MyReservation reservedItems={upcomingReservations} action={handleSlotClick} />
      ) : null}

      <DatePickerMobile
        datesRange={datesRange}
        selectDate={handleSelectDate}
        targetDate={targetDate}
      />

      <ReservationList
        upcomingReservations={upcomingReservations}
        reservations={reservations}
        handleSlotClick={handleSlotClick}
        isRequesting={isRequesting}
        closedClubText={closedClubText}
      />
    </div>
  );
};

MainContentMobile.propTypes = {
  datesRange: PropTypes.oneOfType([PropTypes.array, PropTypes.arrayOf(PropTypes.object)])
    .isRequired,
  targetDate: PropTypes.object.isRequired,
  targetClub: PropTypes.string.isRequired,
  handleChangeClub: PropTypes.func.isRequired,
  handleChangeRoom: PropTypes.func.isRequired,
  handleSelectDate: PropTypes.func.isRequired,
  reservations: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.arrayOf(PropTypes.object),
  ]).isRequired,
  upcomingReservations: PropTypes.array.isRequired,
  handleSlotClick: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  targetRoom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MainContentMobile.defaultProps = {
  targetRoom: null,
};

export default MainContentMobile;
